"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _react = require("react");
class ErrorBoundary extends _react.Component {
  constructor() {
    super();
    this.state = {
      error: null
    };
  }
  componentDidMount() {
    window.addEventListener('unhandledrejection', this.promiseRejectionHandler);
  }
  componentDidCatch(error) {
    this.setState(prevState => ({
      ...prevState,
      error
    }));
  }
  componentWillUnmount() {
    window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
  }
  promiseRejectionHandler = event => {
    this.setState(prevState => ({
      ...prevState,
      error: event.reason
    }));
  };
  render() {
    const {
      renderFallback,
      children
    } = this.props;
    const {
      error
    } = this.state;
    return error ? renderFallback(error) : children;
  }
}
exports.ErrorBoundary = ErrorBoundary;